//************** Custom size selector PDP *****************//
function changeNameInputSize() {
    const viewportWidth = window.innerWidth;
    const inputSizeSelectors = document.querySelectorAll('input[data-input-size-selector]');
    
    if (inputSizeSelectors) {
        const mobileSelector = viewportWidth <= 741;

        inputSizeSelectors.forEach(selector => {
            const optionName = selector.getAttribute('data-option-name');
            const isMobile = selector.hasAttribute('data-input-size-selector-mobile');

            selector.setAttribute("name", isMobile === mobileSelector ? optionName : isMobile ? '-mobile' : '-desktop');
        });
    }
}

window.addEventListener('resize', changeNameInputSize);
window.addEventListener('load', changeNameInputSize);

//************************************************//


//************** Custom color selector PDP *****************//
const anchorColorSelectors = document.querySelectorAll('.customLink-color-selector');
if(anchorColorSelectors){
    anchorColorSelectors.forEach(anchorS => {
        anchorS.addEventListener('click', function(event) {
            // Prevent the default behavior of the anchor link
            event.preventDefault();
        
            // Manually trigger the click event on the anchor link
            window.location.href = this.href;
          });
    })
}


const listSizeSelector = document.querySelector('ul[data-ul-size-selector]');
if (listSizeSelector){
        listSizeSelector.addEventListener('click', () => {
            setTimeout(() => {
                document.querySelector('#details-size-selector').removeAttribute('open');
            }, 300)
        })
}